//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionCameraFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 14.5C13.6569 14.5 15 13.1569 15 11.5C15 9.84315 13.6569 8.5 12 8.5C10.3431 8.5 9 9.84315 9 11.5C9 13.1569 10.3431 14.5 12 14.5Z" fill="currentColor" /><path d="M17.47 4L16.21 2.5H7.79L6.53 4H2V20H22V4H17.47ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5Z" fill="currentColor" /></svg>;
}
export default IconActionCameraFill;